<template>
  <div>
    <headerSection :exam_type="$route.params.exam_type || null" :isShowType="false" :isShowText="true" />
    <!-- <div class="header d-flex flex-wrap p-2 p-md-4 px-md-5 align-content-center justify-content-between w-100">
      <div class="d-flex align-content-center mb-2 mb-md-0">
        <div class="mr-2">
          <img v-if="$route.params.exam_type === 'toeic'" src="@/assets/image/toeic/toeic_exam/TOEIC.png" alt="" class="object-contain d-inline-block w-100">
          <img v-else src="@/assets/image/toeic/toeic_exam/TOEIC_bridge.png" alt="" class="object-contain d-inline-block w-100">
        </div>
        <div class="">
          <img src="@/assets/image/toeic/toeic_exam/exam_test_Speaking.png" alt="" class="object-contain d-inline-block">
        </div>
      </div>
    </div> -->
    <div class="container my-4">
      <div v-for="(value, key, index) in menuData" :key="index"
        class="row w-100 mx-0">
        <div v-for="(child, idx, idx2) in value" :key="idx2"
          class="col-12 col-lg-6 mb-3"
          :class="{ 'col-lg-3': selectedType !== null }">

          <div class="p-3 bg-white rounded">
            <p class="mb-2 text-left font-bold text-xl">第{{ chineseNumbers[idx2] }}回</p>
            <div class="row">
              <div class="col-12 col-md-6 mb-3"
                v-for="(child2, idx2) in child"
                :key="idx2"
                :class="{
                  'd-none': (selectedType !== null && child2.type !== selectedType) || child2.type === 'writing',
                  'col-12': selectedType !== null && child2.type === selectedType
                }">

                <div class="card" :class="{ 'border-green-01': child2.type === 'speaking', 'border-purple-01': child2.type === 'writing' }">
                  <p class="card-header text-center text-white font-bold text-xl"
                    :class="{ 'bg-green-01': child2.type === 'speaking', 'bg-purple-01': child2.type === 'writing' }">
                    <span v-if="child2.type === 'speaking'">口說模擬</span>
                    <span v-if="child2.type === 'writing'">寫作模擬</span>
                  </p>

                  <div class="card-body">
                    <p class="text-center fs-6 font-bold mb-2 text-lg">考試次數</p>
                    <p class="text-center fs-5 font-bold mb-3 pb-2 text-2xl"
                      :class="{ 'border-primary': child2.type === 'speaking', 'border-success': child2.type === 'writing' }">
                      {{ child2.times }}
                    </p>

                    <!-- <p class="text-center small font-bold">
                      <span v-if="!child2.due_at" class="text-muted">尚未開始練習</span>
                      <span v-else-if="moment(child2.due_at).isBefore(moment(), 'second')" class="text-muted">
                        有效期已過，請重新扣點
                      </span>
                      <span v-else class="text-success">
                        有效時間：{{ moment(child2.due_at).format('YYYY/MM/DD') }}
                      </span>
                    </p> -->

                    <div class="d-flex flex-wrap mt-3">
                      <router-link v-if="child2.record_id"
                        :to="{ name: 'TOEIC_report', params: { practice_type: child2.type, record_id: child2.record_id } }"
                        class="flex-1 text-center border border-2 rounded py-2 m-1 font-bold pointer"
                        :class="{ 'check_record_speaking': child2.type === 'speaking', 'check_record_writing': child2.type === 'writing' }">
                        查看紀錄
                      </router-link>
                      <div v-else
                        class="flex-1 text-center border border-2 rounded py-2 m-1 font-bold text-muted border-muted">
                        尚無紀錄
                      </div>
                      <a class="flex-1 text-center border border-2 rounded py-2 m-1 font-bold pointer startExam"
                        @click="startExam(child2, key, idx)">
                        進入考試
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/store/api'
  import examJs from '@/components/AiHelper/examJs_toeic.js'
  import moment from 'moment'
  import headerSection from '@/components/AiHelper/toeic/headerSection'
  export default {
    name: 'List',
    components: {
      headerSection
    },
    data () {
      return {
        menuData: null,
        chineseNumbers: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
        selectedLevel: null,
        selectedType: null,
        pageSize: 40,
        pagination: {
          currentPage: 1,
          length: 1
        }
      }
    },
    mixins: [
      examJs
    ],
    watch: {
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ]),
      returnRouter () {
        if (this.$route.params.exam_type === 'toeic') {
          return 'TOEIC_exam'
        } else {
          return 'TOEIC_bridge'
        }
      },
      returnRouterName () {
        if (this.$route.params.exam_type === 'toeic') {
          return 'TOEIC'
        } else {
          return 'TOEIC Bridge'
        }
      },
      returnData () {
        if (this.$route.params.exam_type === 'toeic') {
          return this.menuData.toeic
        } else {
          return this.menuData.toeic_bridge
        }
      }
    },
    mounted () {
      this.getListData()
    },
    methods: {
      ...mapActions({
        doGetPoints: 'getRemainPoints'
      }),
      getListData () {
        let type = this.$route.params.exam_type === 'toeic' ? 'toeic' : 'toeic_bridge'
        let path = `assessments/${type}/categories/records`
        api.get(path)
        .then((res) => {
          console.log(res.data)
          this.menuData = res.data
        })
        .catch((err) => {
          console.log(err)
        })
      },
      startExam (child2) {
        if (!child2.due_at || moment(child2.due_at).isBefore(moment(), 'second')) {
          this.preCheckPoint(child2)
        } else if (child2.due_at && moment(child2.due_at).isAfter(moment(), 'second')) {
          this.checkAuth(child2)
        }
      },

      async checkAuth (item) {
        let result = await this.post_records_purchase(item.id, item.type)
        if (result && result.record_id) {
          this.$router.push({ name: this.returnRouter, params: { practice_type: item.type, exam_id: item.id }, query: { record_id: result.record_id } })
        }
      },

      preCheckPoint (item, index, idx) {
        let self = this
        let result
        const myPromise = new Promise(async(resolve, reject) => {
          self.$store.dispatch('isLoading', true)
          await self.$store.dispatch('getRemainPoints')
          result = await self.post_records_purchase(item.id, item.type)

          if (result?.record_id) {
            resolve(2)
            self.$store.dispatch('isLoading', false)
          } else if (self.remainPoints >= result.points && result.points) {
            resolve(1)
            self.$store.dispatch('isLoading', false)
          } else {
            reject(2)
            self.$store.dispatch('isLoading', false)
          }
        })
        myPromise.then(async(status) => {
            if (status === 2) {
              await self.post_assessments_records_start(item)

              self.getListData()
            } else {
              self.confirmPurchase(item, index, idx, result.points)
            }
          }, (fail) => {
            console.log(fail)
            self.rejectAlert()
          })
      },

      async confirmPurchase (item, level, index, point) {
        let self = this

        let type = item.type === 'writing' ? '寫作練習' : '口說練習'
        let html = `<p class="text-lg text-black mb-3 font-semibold">請問是否要開始</p>
          <p class="text-xl gept_main_color4 mb-3 font-semibold">${this.returnRouterName}<span class=" rounded-lg p-1 ml-2 gept_main_bg6 text-white text-lg">${type}</span></p>
          <p class="text-lg text-black mb-1 font-semibold">按下確認後，將扣除50點，每次扣點可使用7天。</p>
          <p class="text-lg text-black mb-5 font-semibold">本次扣除可使用至<span class="gept_main_color4">${moment().add(7, 'days').endOf("day").format("YYYY-MM-DD")}</span></p>
          <div class="gept_main_bg11 text-lg p-3 max-w-sm mx-auto text-black font-normal">
            <div class="d-flex justify-content-between border-b border_main5 p-1">
              <p class="mb-0">目前總點數：</p>
              <p class="mb-0">${self.remainPoints} 點</p>
            </div>
            <div class="d-flex justify-content-between border-b border_main5 p-1">
              <p class="mb-0">需扣除：</p>
              <p class="mb-0">50 點</p>
            </div>
            <div class="d-flex justify-content-between p-1">
              <p class="mb-0">扣除後點數：</p>
              <p class="mb-0">${self.remainPoints - 50} 點</p>
            </div>
          </div>`

          self.$swal.fire({
            html: html,
            showCloseButton: false,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText: `確認`,
            denyButtonText: `返回`,
            title: '扣點說明',
            customClass: {
              title: 'text-white text-xl m-0',
              container: '',
              popup: 'p-0 max-w-2xl w-100',
              header: 'justify-content-center align-items-center gept_main_bg py-4',
              closeButton: 'swal-closeButton',
              htmlContainer: 'my-4 text-xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit-gept order-2',
              denyButton: 'btn-deny-gept order-1'
            }
          })
        .then(async(result) => {
            if (result.isConfirmed === true) {
              await self.post_assessments_records_start(item)

              self.getListData()
            }
          }
        )
      },

      rejectAlert () {
        let self = this

        let html = `<p class="text-lg text-black mb-5 font-semibold">點數餘額不足支付本課程，請於LiveABC官網加購</p>
          <a href="https://store.liveabc.com/products/digital?category=221" target="_blank" class="text-xl gept_main_bg5 text-white mb-3 font-semibold pointer px-3 py-2 inline-block">購買網址</a>`

          self.$swal.fire({
            html: html,
            showCloseButton: true,
            showDenyButton: false,
            showConfirmButton: false,
            focusConfirm: false,
            confirmButtonText: `確認`,
            denyButtonText: `返回`,
            title: '點數餘額不足',
            customClass: {
              title: 'text-white text-xl m-0',
              container: '',
              popup: 'p-0 max-w-2xl w-100',
              header: 'gept_main_bg py-4 position-relative',
              closeButton: 'position-absolute swal-closeButton',
              htmlContainer: 'my-4 text-xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit-gept order-2 ',
              denyButton: 'btn-deny-gept order-1'
            }
          })
        .then((result) => {
            if (result.isConfirmed === true) {
              self.post_gept_records_start(item)
            }
          }
        )
      },

      checkReport (type, id) {
        this.$router.push({ name: 'TOEIC_report', params: { practice_type: type, record_id: id } })
      }
    }
  }
</script>
<style lang="scss">
a {
  &:hover {
    text-decoration: none !important;
  }
}
.border-2 {
    border-width: 2px !important;
}
.header {
  background-color: #166CB3;
}
.main {
  background-color: rgb(214, 224, 233);
  min-height: 100vh;
}
.bg-green-01 {
  background-color: rgba(45, 154, 169, 1);
}
.bg-purple-01 {
  background-color: rgba(108, 124, 204, 1);
}
.border-green-01 {
  border-color: rgba(45, 154, 169, 1);
}
.border-purple-01 {
  border-color: rgba(108, 124, 204, 1);
}
.check_record_speaking {
  border-color: rgba(45, 154, 169, 1) !important;
  color: rgba(45, 154, 169, 1);
}
.check_record_writing {
  border-color: rgba(108, 124, 204, 1) !important;
  color: rgba(108, 124, 204, 1);
}
.startExam {
  border-color: rgba(255, 89, 52, 1) !important;
  color: rgba(255, 89, 52, 1) !important;
}
.border-b {
  border-bottom: 1px solid #145F7F;
}
</style>
